import React, { Component } from 'react';
import { Table, Modal, Button, Input, Tabs, message } from 'antd';
import ExportUtil from '../../common/ExportUtil';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

export default class ModelTable  extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = record => {
        this.setState({
            record,
            visible: true,
        },this.loadData);
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record } = this.state;
        const { queryData, loadDataUrl, resData, resDataType = 'arr', queryDatas = [] } = this.props;
        const data = {
            ...queryData
        }
        queryDatas.forEach( el => {
            data[el] = record[el]
        })
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: loadDataUrl,
            data,
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data:  resDataType == 'arr' ? res[resData] || [] : [res[resData]],
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

   

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item } ));
        return dataSource;
    }

    getFileDateSource = () => {
        const { data = [] } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: index + 1,
                ...item,
                name: item.name
            })
        });

        return dataSource;
    }

    render() {
        const { visible, loading } = this.state;
        const { modelTitle, modelWidth, tableColumns, getFileDateSource } = this.props;
        return (
            <Modal
                title={modelTitle}
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={modelWidth}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginTop: -1, borderBottom: '1px solid #e9e9e9' }}>
                        <Table
                            bordered
                            loading={loading}
                            pagination={false}
                            scroll={{x: 750, y: 300}}
                            columns={tableColumns}
                            dataSource={ getFileDateSource ? this.getFileDateSource() : this.getDataSource()}
                        />
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/ModelTable.js